// src/components/atoms/VideoPlayButton.js

import React from "react";
import { IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";

const VideoPlayButton = ({ isPlaying, onClick }) => {
  return (
    <IconButton onClick={onClick} aria-label={isPlaying ? "Pause" : "Play"}>
      {isPlaying ? (
        <PauseIcon sx={{ color: "white" }} />
      ) : (
        <PlayArrowIcon sx={{ color: "white" }} />
      )}
    </IconButton>
  );
};

export default VideoPlayButton;
